import { NgModule } from '@angular/core';
import { TimeAgoPipe } from './time-ago';

@NgModule({
  declarations: [
    TimeAgoPipe
  ],
  imports: [ ],
  exports: [
    TimeAgoPipe
  ]
})
export class TimeAgoModule {}



// WEBPACK FOOTER //
// ./src/pipes/time-ago/time-ago.module.ts